import { useState } from 'react';

import VIPCodeForm, { VIPCodeFormProps } from './components/VIPCodeForm';
import VIPCodeInfo from './components/VIPCodeInfo';
import { SitePricingDiscount } from '../../../store/features/discounts/types';

interface VIPCodeProps<T> extends Omit<VIPCodeFormProps, 'onSuccess'> {
  codeDiscountResult?: SitePricingDiscount;
  onCodeChange?: (vipCode: string) => Promise<T>;
}

export default function VIPCode<T>(props: VIPCodeProps<T>) {
  const { codeDiscountResult, code, onCodeChange, onValidateVipCode } = props;
  const [showCodeInfo, setShowCodeInfo] = useState(!!code);

  const codeInfoCloseHandler = () => {
    setShowCodeInfo(false);
  };

  const successApplyingVipCodeHandler = (vipCode: string) => {
    if (onCodeChange) {
      onCodeChange(vipCode).then(() => {
        // fix for GEN-1040
        setShowCodeInfo(true);
      });
    } else {
      setShowCodeInfo(true);
    }
  };

  return (
    <div className="informa-payment-vip-code-widget">
      {showCodeInfo ? (
        <VIPCodeInfo
          code={code}
          onCloseHandler={codeInfoCloseHandler}
          codeDiscountResult={codeDiscountResult}
        />
      ) : (
        <VIPCodeForm
          code={code}
          onSuccess={successApplyingVipCodeHandler}
          onValidateVipCode={onValidateVipCode}
        />
      )}
    </div>
  );
}
